import { FC } from 'react'
import { Stack, Typography } from '@mui/material'
import ErrorOutlineRoundedIcon from '@mui/icons-material/ErrorOutlineRounded'
import { useTranslation } from 'react-i18next'

import { CORAL_100, CORAL_600, GRAY_700 } from 'constants/styling/theme'

/**
 * @component
 * Terminal screen in the Propstack embed when Stripe returns from a failed payment. The order was placed
 * before the payment, and the return reloads the flow with nothing in it, so this is all that is left to say.
 *
 * @example <EmbedPaymentFailed />
 */
export const EmbedPaymentFailed: FC = () => {
  const { t } = useTranslation(['payment_status_page'])

  return (
    <Stack
      gap={3}
      alignItems="center"
      justifyContent="center"
      role="alert"
      data-testid="pf-revamp-embed-payment-failed"
      sx={{ height: '100%', minHeight: '60vh', padding: 4, textAlign: 'center' }}
    >
      <Stack
        alignItems="center"
        justifyContent="center"
        sx={{ width: 96, height: 96, borderRadius: '50%', backgroundColor: CORAL_100 }}
      >
        <ErrorOutlineRoundedIcon sx={{ fontSize: 48, color: CORAL_600 }} />
      </Stack>

      <Stack gap={1} alignItems="center">
        <Typography variant="h5">{t('payment_status_page:DEAL.CARD.ERROR.title')}</Typography>
        <Typography variant="body1" color={GRAY_700} sx={{ maxWidth: 480 }}>
          {t('payment_status_page:DEAL.CARD.ERROR.text')}
        </Typography>
      </Stack>
    </Stack>
  )
}
